import { useDispatch, useSelector } from 'react-redux';

import { LOCALES } from 'i18n/locales';
import { useIntl } from 'react-intl';

import { usePageLangAttribute } from 'i18n/localeUtils';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './SelectLocale.module.scss';
import useAuth from 'client/utils/auth/useAuth';
import { manageLocaleChange } from 'client/utils/i18n/i18nUtils';

const SelectLocale = () => {
    const dispatch = useDispatch();
    const { isAuthenticated } = useAuth();
    const currentLocale = useSelector(state => state?.locale?.current);
    const intl = useIntl();
    usePageLangAttribute();
    const myManageLocaleChange = () => manageLocaleChange(currentLocale, isAuthenticated, dispatch);

    const handleKeyDown = evt => {
        if (evt.keyCode === 13 || evt.key === 'Enter') {
            myManageLocaleChange();
        }
    };

    return (
        <li
            className={['govuk-header__navigation-item', styles.navItems].join(' ')}
            role="none"
            data-testid="navbar.link.selectLocale"
        >
            {Object.entries(LOCALES).map(([localeKey, localeValue]) => {
                const isCurrentLocale = localeValue === currentLocale;
                return <a
                    className={isCurrentLocale
                        ? [styles.languagedSelected]
                        : [styles.languageNotSelected]}
                    role="menuitem"
                    key={localeKey}
                    lang={localeValue === LOCALES.ENGLISH ? LOCALES.ENGLISH : LOCALES.WELSH }
                    aria-current={isCurrentLocale ? 'page' : null}
                    aria-label={
                        localeValue === LOCALES.ENGLISH
                            ? intl.formatMessage({ id: 'navbar.link.selectLocale.ariaLabel.en' })
                            : intl.formatMessage({ id: 'navbar.link.selectLocale.ariaLabel.cy' })
                    }
                    onClick={isCurrentLocale ? null : myManageLocaleChange}
                    onKeyDown={isCurrentLocale ? null : handleKeyDown}
                    data-testid={localeValue === LOCALES.ENGLISH ? 'navbar.selectLocale.English' : 'navbar.selectLocale.Welsh' }
                    tabIndex={isCurrentLocale ? -1 : 0}
                >
                    {localeValue === LOCALES.ENGLISH ? 'English' : 'Cymraeg'}  {/* don't translate */}
                </a>;
            }).reduce((prev, curr) => [prev, ' | ', curr])}
        </li>
    );
};

SelectLocale.propTypes = {
    ...defaultAriaProps
};

export default SelectLocale;
